import React from 'react';
import { Stack, Typography } from '@mui/material';

const SectionHeading = ({
  eyebrow,
  title,
  description,
  align = 'center',
  maxWidth = 680,
  spacing = 2,
}) => {
  return (
    <Stack
      spacing={spacing}
      alignItems={align === 'center' ? 'center' : 'flex-start'}
      sx={{
        textAlign: { xs: 'left', md: align },
        width: '100%',
        maxWidth,
        ...(align === 'center'
          ? { mx: 'auto' }
          : {
              ml: 0,
              mr: 'auto',
            }),
      }}
    >
      {eyebrow ? (
        <Typography variant='bodySmallCaps' color='secondary.main'>
          {eyebrow}
        </Typography>
      ) : null}
      {title ? (
        <Typography variant='h2'>{title}</Typography>
      ) : null}
      {description ? (
        <Typography variant='body1'>{description}</Typography>
      ) : null}
    </Stack>
  );
};

export default SectionHeading;
